import { render, staticRenderFns } from "./TablaComponenteButton.vue?vue&type=template&id=1e355c4e&scoped=true"
import script from "./TablaComponenteButton.vue?vue&type=script&lang=js"
export * from "./TablaComponenteButton.vue?vue&type=script&lang=js"
import style0 from "./TablaComponenteButton.vue?vue&type=style&index=0&id=1e355c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e355c4e",
  null
  
)

export default component.exports